import { Link } from '@ui-components/actions/Link'
import { ReactNode } from 'react'

import { useCommonMessages } from '../context/CommonMessages'

export interface ExternalLinkProps {
  children: ReactNode
  href: string
  onClick?: () => void
  'aria-label'?: string
}

export const ExternalLink = ({ children, onClick, href, 'aria-label': ariaLabel }: ExternalLinkProps) => {
  const { opensInANewTab } = useCommonMessages()

  return (
    <Link
      href={href}
      onClick={onClick}
      isInline={true}
      external={true}
      iconPos="after"
      target="_blank"
      aria-label={ariaLabel ?? opensInANewTab}
    >
      {children}
    </Link>
  )
}
